@if (title) {
    <ion-header>
        <ion-toolbar color="light">
            <ion-title>{{ title }}</ion-title>
        </ion-toolbar>
    </ion-header>
}

<ion-content class="ion-padding">
    {{ message }}
</ion-content>

<ion-footer class="ion-no-border">
    <ion-toolbar class="action-buttons">
        <ion-buttons slot="start">
            <ion-button (click)="cancel()" color="medium" fill="clear"> Cancel </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button (click)="confirm()" color="primary" fill="solid"> Proceed </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-footer>
